import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Warning",
  "use": "Warning-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol viewBox=\"0 0 20 18\" id=\"Warning\"><path d=\"M0 17.325h20L10 0 0 17.325zm10.91-2.735H9.09v-1.824h1.82v1.824zm0-3.648H9.09V7.295h1.82v3.647z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol